"use strict";

module.exports = function (rowIds) {
  var _this = this;

  rowIds.forEach(function (id) {
    return _this.selectRow(id);
  });
  return this.selectedRows;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/select-rows.js
// module id = 929
// module chunks = 0